<template>
  <div class="grid h-screen md:grid-cols-2">
    <div class="bg-action-default-hi relative hidden h-full w-full md:block">
      <div class="sticky top-0 flex min-h-full flex-col justify-between">
        <RevIllustration
          :alt="COMPANY_NAME"
          class="mx-56 mt-16"
          :height="76"
          src="/img/logo-white.svg"
          :width="150"
        />

        <div class="mb-52 ml-52 mt-28 flex">
          <RevIllustration
            :alt="COMPANY_NAME"
            class="mt-56"
            :height="50"
            src="/img/register/older_is_better_for_the_world.svg"
            :width="100"
          />
          <RevIllustration
            :alt="COMPANY_NAME"
            class="mb-56"
            :height="50"
            src="/img/register/refurbished_for_the_people.svg"
            :width="100"
          />
        </div>

        <h1 class="text-static-light-hi punchline min-w-full self-center px-52">
          <FormattedMessage :definition="translations.punchline">
            <template #purpleWord>
              <span class="text-[#EAD3FF]">
                {{ i18n(translations.punchlinePurpleWord) }}
              </span>
            </template>
          </FormattedMessage>
        </h1>

        <div class="flex justify-end">
          <RevIllustration
            :alt="COMPANY_NAME"
            class="left-0 mb-28 mr-52"
            :height="70"
            src="/img/register/standing_boy.svg"
            :width="140"
          />
        </div>
      </div>
    </div>

    <section class="h-full w-full overflow-y-scroll px-52">
      <div class="mb-32 mt-12 flex justify-between">
        <div>
          <RevIllustration
            :alt="COMPANY_NAME"
            class="block md:hidden"
            :height="76"
            src="/img/logo-black.svg"
            :width="150"
          />
        </div>

        <TheLanguageSelect />
      </div>

      <h1 class="heading-1 mb-16">
        {{ i18n(translations.pageTitle) }}
      </h1>

      <div class="bg-static-info-mid rounded-lg mb-32 w-full py-16 pl-16 pr-8">
        {{ i18n(translations.connectedUserText, { email: user.email }) }}
        &nbsp;
        <RevLink @click="logout">
          {{ i18n(translations.logoutLink) }}
        </RevLink>
      </div>
      <RegisterForm class="mb-20" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import translations from './Register.translations'
import RegisterForm from './components/register-form/RegisterForm.vue'

const i18n = useI18n()
const { user } = useUserStore()

const COMPANY_NAME = 'Back Market'

const { logout } = useLogout()
</script>
